<template>
  <div id="participantroster">
    <Printer title="Participant Rosters">
      <template v-slot:printContent>
        <p style="font-size: 8pt">
          This form will be used TWICE:
        </p>
        <p style="font-size: 8pt">
          Thirty days BEFORE the course, fill in the information for each registered
          participant and the course information. Save it as "30-day Pre-course
          Participant Roster." Submit it as directed in the
          <i>Schedule of Course Reports and Transmitals.</i>
        </p>
        <p style="font-size: 8pt">
          By thirty days AFTER the course, update the 30-day Pre-course Participant
          Roster with any additional participants and remove those who have dropped.
          Save the new report as a separate "Final Participant Roster." Submit is as
          directed in the <i>Schedule of Course Reports and Transmittals.</i>
        </p>
        <div class="row">
          <div class="ml-1 col-2">
            <b>Course Number:</b>
          </div>
          <div class="data-field col-3">
            {{ reportInfo.Header.CourseName }}
          </div>
          <div class="text-right col-2">
            <b>Course Dates:</b>
          </div>
          <div
            class="data-field col-4"
          >
            {{ reportInfo.Header.Dates }}
          </div>
        </div>
        <div class="row mb-3">
          <div class="ml-1 col-2">
            <b>Host Council:</b>
          </div>
          <div class="data-field col-3">
            {{ reportInfo.Header.HostingCouncil }}
          </div>
          <div class="text-right col-2">
            <b>Location(s):</b>
          </div>
          <div
            class="data-field col-4"
          >
            {{ reportInfo.Header.Locations }}
          </div>
        </div>

        <div class="row ml-1 mr-1">
          <div
            class="float-left r-header"
            style="width:100px;"
          >
            Name (Last, First)
          </div>
          <div
            class="float-left r-header"
            style="width:35px;"
          >
            Age
          </div>
          <div
            class="float-left r-header"
            style="width:35px;"
          >
            Sex
          </div>
          <div
            class="float-left r-header"
            style="width:50px;"
          >
            Ethnicity
          </div>
          <div
            class="float-left r-header"
            style="width:170px;"
          >
            Mailing Address
          </div>
          <div
            class="float-left r-header"
            style="width:75px;"
          >
            Phone Number
          </div>
          <div
            class="float-left r-header"
            style="width:120px;"
          >
            Email Address
          </div>
          <div
            class="float-left r-header"
            style="width:100px;"
          >
            Primary Registered Position
          </div>
          <div
            class="float-left r-header"
            style="width:140px;"
          >
            District/Council
          </div>
          <div
            class="float-left r-header"
            style="width:90px;"
          >
            Occupation
          </div>
          <div
            class="float-left r-header"
            style="width:75px;"
          >
            Ticket Completion Date
          </div>
        </div>
        <div
          class="row ml-1 mr-1"
          v-for="r in reportInfo.Details"
          :key="r.FullName"
        >
          <div
            class="float-left r-cell"
            style="width:100px;"
          >
            {{ r.FullName }}
          </div>
          <div
            class="float-left r-cell text-center"
            style="width:35px;"
          >
            {{ r.Age }}
          </div>
          <div
            class="float-left r-cell text-center"
            style="width:35px;"
          >
            {{ r.Sex }}
          </div>
          <div
            class="float-left r-cell"
            style="width:50px;"
          >
            {{ r.Ethnicity }}
          </div>
          <div
            class="float-left r-cell"
            style="width:170px;"
          >
            {{ r.MailingAddress }}
          </div>
          <div
            class="float-left r-cell text-center"
            style="width:75px;"
          >
            {{ r.PhoneNumber }}
          </div>
          <div
            class="float-left r-cell"
            style="width:120px;"
          >
            {{ r.EmailAddress }}
          </div>
          <div
            class="float-left r-cell"
            style="width:100px;"
          >
            {{ r.PrimaryScoutingPosition }}
          </div>
          <div
            class="float-left r-cell"
            style="width:140px;"
          >
            {{ r.DistrictCouncil }}
          </div>
          <div
            class="float-left r-cell"
            style="width:90px;"
          >
            {{ r.Occupation }}
          </div>
          <div
            class="float-left r-cell text-center"
            style="width:75px;"
          >
            {{ r.CompleteDate }}
          </div>
        </div>
      </template>
    </Printer>
  </div>
</template>

<script>
import reportsApi from '@/services/api/reports.js'
import Printer from '@/components/_main/printer.vue'

export default {
  name: 'ReportParticipantRoster',
  components: {
    Printer
  },
  data: function () {
    return {
      reportInfo: {
        Header: {},
        Details: []
      },
      cellStyle: {
        padding: '0',
        'font-size': '5pt',
        border: '1px solid black',
        'line-height': '12px'
      },
      headerCellStyle: {
        padding: '0',
        'font-size': '5pt',
        'text-align': 'center',
        'overflow-wrap': 'break-word',
        border: '1px solid black'
      }
    }
  },
  mounted: function () {
    reportsApi
      .getParticipantRosterReport(this.$root.courseKey)
      .then(response => {
        this.reportInfo = response
      })
      .catch(error => {
        console.log(error)
        this.$notify({
          message: 'There was an error retrieving your data.',
          icon: 'bi bi-exclamation-circle-fill',
          type: 'error',
          horizontalAlign: 'center',
          timeout: 2000
        })
        this.errormessage = error
      })
      .finally(() => {
        this.loading = false
      })
  }
}
</script>
